export const NAME = 'bandingTypes';